import BookingParticipant from "./BookingParticipant";

export default class Search {
    constructor(data) {

        // Model data
        this.data = data;
    }

    static putSessionStorage(data) {
        sessionStorage.setItem("scol_search", JSON.stringify(data));
    }

    static defaults() {
        return {
            l: null,
            r: null,
            p: {
                a: 1,
                c: 0,
            },
            ages: [],
            tid: null,
            code: null,
            z: 1,
        };
    }

    static personsReadable(data) {
        let value = "";
        if (data.p.a) {
            value +=
                data.p.a +
                " " +
                (data.p.a == 1 ? "Erwachsener" : "Erwachsene");
        }
        if (data.p.a && data.p.c) {
            value += ", ";
        }
        if (data.p.c) {
            value += data.p.c + " " + (data.p.c == 1 ? "Kind" : "Kinder");
        }
        return value
    }

    get storage() {
        return JSON.parse(sessionStorage.getItem("scol_search"));
    }

    fromStorage() {
        this.data = this.storage;
        return this;
    }

    toStorage() {
        sessionStorage.setItem("scol_search", JSON.stringify(this.data));
        return this;
    }

    get location() {
        return this.get('l');
    }

    get adults_count() {
        return this.get('p.a');
    }

    get childs_count() {
        return this.get('p.c');
    }

    get participants() {

        let participants = {};

        let key = 0;

        // Adults
        for (let i = 0; i < this.adults_count; i++) {
            participants[key] = BookingParticipant.make();
            key++;
        }

        // Childs
        for (let i = 0; i < this.adults_count; i++) {
            participants[key] = BookingParticipant.make({
                adult: false,
                child: true,
            });
            key++;
        }

        return participants;
    }

    get timespan() {
        const range = this.get('r');
        const options = { year: 'numeric', month: "2-digit", day: "2-digit" };

        if (!range || !range[0]) {
            return;
        }

        const date1 = new Date(range[0]);
        const from =
            date1.toLocaleDateString("de-DE", { weekday: "long" }) +
            ", " +
            date1.toLocaleDateString("de-DE", options);


        if (!range[1]) {
            return from;
        }

        const date2 = new Date(range[1]);
        const to =
            date2.toLocaleDateString("de-DE", { weekday: "long" }) +
            ", " +
            date2.toLocaleDateString("de-DE", options);


        if (from == to) {
            return from;
        }

        return `${from} - ${to}`;
    }

    get(key) {
        return _.get(this.data, key);
    }
}
